/**
 * User List Modal
 * Shows a list of users (followers or following) with links to their profiles.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import './UserListModal.css';

const UserListModal = ({ title, users, onClose }) => {
  return (
    <div className="user-list-overlay" onClick={onClose}>
      <div className="user-list-modal" onClick={(e) => e.stopPropagation()}>
        <div className="user-list-header">
          <h3>{title}</h3>
          <button className="user-list-close" onClick={onClose} aria-label="Close">
            <X size={20} />
          </button>
        </div>
        <div className="user-list-body">
          {(!users || users.length === 0) ? (
            <p className="user-list-empty">No users yet.</p>
          ) : (
            users.map((u) => (
              <Link
                key={u._id}
                to={`/profile/${u._id}`}
                className="user-list-row"
                onClick={onClose}
              >
                {u.avatar ? (
                  <img src={u.avatar} alt={u.username} className="user-list-avatar" />
                ) : (
                  <div className="user-list-avatar user-list-avatar-placeholder">
                    {u.username?.charAt(0).toUpperCase()}
                  </div>
                )}
                <div className="user-list-names">
                  <span className="user-list-name">{u.fullName || u.username}</span>
                  <span className="user-list-username">@{u.username}</span>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default UserListModal;
